export enum FieldTypes {
  text = 'text',
  number = 'number',
  email = 'email',
  radio = 'radio',
  checkbox = 'checkbox',
  select = 'select',
  date = 'date',
}
